import classNames from 'classnames';

import styles from './Success.module.scss';
import success from './assets/success.svg';

import { QuestionnaireFormProps, QuestionnaireQuestions } from '../../models';
import { getButton, GetButtonProps } from '../utils/getButton';
import { IconTile, IconTileProps } from '../IconTile/IconTile';

type SuccessProps<Questionnaire extends QuestionnaireQuestions> = {
  title: string;
  description?: string;
  buttonProps: GetButtonProps[];
  infoCards?: IconTileProps[];
} & QuestionnaireFormProps<Questionnaire>;

export const Success = <Questionnaire extends QuestionnaireQuestions>({
  title,
  description,
  buttonProps,
  onSubmitValue,
  infoCards = [],
}: SuccessProps<Questionnaire>) => (
  <div
    className={classNames(
      styles.container,
      'd-flex fd-column ai-center jc-center ml-auto mr-auto px16'
    )}
  >
    <img src={success} className="wmn2 p16" alt="" />
    <h2 className="p-h1 ta-center">{title}</h2>

    {description && <h4 className="p-p mt24 ta-center wmx8">{description}</h4>}

    {infoCards.length > 0 && (
      <div className={`d-grid gap16 mt16 w100 ${styles.grid}`}>
        {infoCards.map(({ children, ...infoCardProps }, index) => (
          <IconTile
            {...infoCardProps}
            paragraphClassName="p-p--small"
            key={index}
          >
            {children}
          </IconTile>
        ))}
      </div>
    )}

    <div
      className={classNames(
        'd-flex fd-column gap16 mt24 ai-center jc-center',
        styles.buttonContainer
      )}
    >
      {buttonProps.map((buttonBlockerProps, index) =>
        getButton({ index, onSubmitValue, ...buttonBlockerProps })
      )}
    </div>
  </div>
);
